var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-obs-department-detail',{staticClass:"pt-obs-department-detail__page",attrs:{"id":_vm.id,"isEdit":_vm.is_edit}})}
var staticRenderFns = []

export { render, staticRenderFns }